/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Attachment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ImageAttachment from './ImageAttachment/index'
import No from './No/index'
import OtherAttachment from './OtherAttachment/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Attachment({
  children,
  viewPath = "/DesignSystem/CommsThreadEventAttachments/Content/Attachment"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let attachmentTypeValueData = fromData.useDataFormat({ viewPath,
context: 'attachment',
path: 'type',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: attachmentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageAttachment'}>
<ImageAttachment
  viewPath={`${viewPath}/ImageAttachment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherAttachment'}>
<OtherAttachment
  viewPath={`${viewPath}/OtherAttachment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}